import React, { FunctionComponent } from "react";

import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styles from "./styles";

interface CheckboxProps {
  white?: boolean;
  active?: boolean;
  onChange?: (active: boolean) => void;
}

const Checkbox: FunctionComponent<CheckboxProps> = ({
  white,
  active,
  onChange
}) => {
  const { CheckboxWrapper } = styles;

  return (
    <CheckboxWrapper
      white={white}
      active={active}
      onClick={() => onChange && onChange(!active)}
    >
      {active && (
        <FontAwesomeIcon
          size="sm"
          icon={faCheck}
          color={white ? "black" : "white"}
        />
      )}
    </CheckboxWrapper>
  );
};

export default Checkbox;
